import React from 'react'
import User from './User'

function About() {
  return (
    <div>About:
      <hr/>
      <User name={"vishal_Maheshwari"}/>
    </div>
  )
}

export default About